import en from './en/translation'
import hu from './hu/translation'
import { initReactI18next } from 'react-i18next'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .init({
    resources: {
      en: {
        translation: en,
      },
      hu: {
        translation: hu,
      },
    },

    fallbackLng: 'en',

    keySeparator: '.',

    interpolation: {
      escapeValue: false, // react already safes from xss
    },

    detection: {
      order: ['localStorage', 'cookie', 'navigator'],
      lookupCookie: 'language',
      lookupLocalStorage: 'language',
      caches: ['localStorage', 'cookie'],
    },
  })

export default i18n
